<div>
  <div class="brand-bar margin-bottom-header"></div>
  <div class="grid align-center">
    <div class="col-lg-2 ml-2 mr-2">
      <div class="box">
        <h1>{{ pupilData.studentName }} {{ offRoleIndicator }}</h1>
      </div>
    </div>
  </div>
</div>
<div class="flex">
  <div>
    <div><label>Gender</label></div>
    <div class="margin-top">
      <span name="gender">{{ gender }}</span>
    </div>
  </div>
  <p-divider layout="vertical"></p-divider>
  <div>
    <div>
      <label>Date of Birth</label>
    </div>
    <div class="margin-top overflow-wrap">
      <span name="dob">{{ pupilData.dob | date: "dd/MM/yyyy" }}</span>
    </div>
  </div>
  <p-divider layout="vertical"></p-divider>
  <div>
    <div>
      <label>Year Group</label>
    </div>
    <div class="margin-top">
      <span name="ncy">{{ pupilData.ncy }}</span>
    </div>
  </div>
  <p-divider layout="vertical"></p-divider>
  <div>
    <div><label>UPN</label></div>
    <div class="margin-top overflow-wrap">
      <span name="upn">{{ upn }}</span>
    </div>
  </div>
  <p-divider layout="vertical"></p-divider>
  <div>
    <div>
      <label>Home LA</label>
    </div>
    <div class="margin-top overflow-wrap">
      <span name="homeLa">{{ homeLa }}</span>
    </div>
  </div>
  <p-divider layout="vertical"></p-divider>
  <div>
    <div><label>LAC</label></div>
    <div class="margin-top">
      <span name="lac">{{ lac }}</span>
    </div>
  </div>
  <p-divider layout="vertical"></p-divider>
  <div>
    <div>
      <label>SEND Status</label>
    </div>
    <div class="margin-top">
      <span name="sen">{{ sen }}</span>
    </div>
  </div>
  <p-divider layout="vertical"></p-divider>
  <div class="currently-excluded">
    <div>
      <label>Currently Excluded?</label>
    </div>
    <div class="margin-top">
      <span name="currentlyExcluded">{{ currentlyExcluded }}</span>
      @if (currentlyExcluded === "Yes") {
        <span><i class="pi pi-exclamation-circle exclamation-style"></i></span>
      }
      <div class="float-right-custom">
        <a
          title="back"
          label="back"
          title="back"
          id="back"
          href="#"
          (click)="navigateBackToExclusionList()"
        >
          < back
        </a>
      </div>
    </div>
  </div>
</div>
<br />
<br />
